'use strict';

/**
 * Webduct API Response Handler (WebductApiResponseHandler.js).
 * Webduct API Response Handler.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2018-2020 Build Centrix.
 *
 * @version
 * 1.15.0 LIBENV-53 Add WebductApiResponseHandler into globalThis for ES6 usage
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
var WebductApiResponseHandler = function() {

    /**
     * Handler
     *
     * This object is returned.
     *
     * @since 1.0.0
     *
     * @type {Object}
     */
    var handler = {};

    /**
     * Error Object
     *
     * @since 1.0.0
     *
     * @type {{code: string, message: string}}
     */
    var badDataObject = {
        code: '5000',
        type: 'bad_data_object',
        message: 'Unexpected data object returned'
    };

    /**
     * Check if is a number
     *
     * @see http://stackoverflow.com/a/1830844/1304537
     *
     * @since 1.0.0
     *
     * @param value
     * @returns {Boolean}
     */
    var isNumber = function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };

    /**
     * Get badDataObject
     *
     * @since 1.0.0
     *
     * @returns {{code: string, message: string}}
     */
    handler.getBadDataObject = function () {
        return badDataObject;
    };

    /**
     * Get bad data code
     *
     * @returns {number}
     */
    handler.getBadDataObjectCode = function () {
        //return badDataObject.code;
        return 5000;
    };

    /**
     * Get bad data message
     *
     * @since 1.0.0
     *
     * @returns {String}
     */
    handler.getBadDataObjectMessage = function () {
        return badDataObject.message;
    };

    /**
     * Get bad data type
     *
     * @since 1.0.0
     *
     * @returns {*}
     */
    handler.getBadDataObjectType = function () {
        return badDataObject.type;
    };

    /**
     * Check for Expected Data Structure
     *
     * Ensure that the data returned contains the expected structure.
     *
     * Returns true if the data structure was valid.
     *
     * @since 1.0.0
     *
     * @param {Object} response
     * @returns {Boolean}
     */
    handler.isExpectedDataStructure = function (response) {

        var result = false; // default to bad data structure

        // ensure the elements of the expected object exist
        if (typeof response.data !== 'undefined' &&
            typeof response.data.status !== 'undefined' &&
            typeof response.data.status.code !== 'undefined' &&
            typeof response.data.data !== 'undefined') {

            result = true;
        }

        return result;
    };

    /**
     * Check for good response code
     *
     * 2000 is a good response code
     * 2400 is a good response code but nothing was found
     *
     * @since 1.0.0
     *
     * @param responseCode
     * @returns {Boolean}
     */
    handler.isGoodResponseCode = function (responseCode) {

        var result = false;

        if (isNumber(responseCode)) {
            responseCode = parseFloat(responseCode);
            if (responseCode === 2000 || responseCode === 2400) {
                result = true;
            }
        }

        return result;
    };

    return handler;

};
globalThis.WebductApiResponseHandler = WebductApiResponseHandler;
// EOF